import React from 'react';
import PropTypes from 'prop-types';
import { FaStethoscope, FaUserInjured, FaChartLine } from 'react-icons/fa';

function RelatorioResumo({
  totalAtendimentos = 0,
  pacientesUnicos = 0,
  atendimentosPorDia = 0,
}) {
  // Verifica se atendimentosPorDia é um número válido
  const atendimentosPorDiaValido = isNaN(atendimentosPorDia)
    ? 0
    : atendimentosPorDia;

  return (
    <div
      className="bg-white shadow-lg p-8 mb-8 rounded-2xl"
      data-testid="relatorio-resumo"
    >
      <h3 className="text-3xl font-bold mb-8 text-gray-900">
        Resumo do Relatório
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div
          className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300 ease-in-out"
          data-testid="total-atendimentos"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-medium text-gray-700">
                Total de Atendimentos
              </p>
              <p
                className="text-4xl font-extrabold text-gray-900 mt-2"
                aria-live="polite"
              >
                {totalAtendimentos}
              </p>
            </div>
            <FaStethoscope
              className="text-5xl text-blue-500 opacity-75"
              aria-hidden="true"
            />
          </div>
        </div>

        <div
          className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300 ease-in-out"
          data-testid="pacientes-unicos"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-medium text-gray-700">
                Pacientes Únicos
              </p>
              <p
                className="text-4xl font-extrabold text-gray-900 mt-2"
                aria-live="polite"
              >
                {pacientesUnicos}
              </p>
            </div>
            <FaUserInjured
              className="text-5xl text-green-500 opacity-75"
              aria-hidden="true"
            />
          </div>
        </div>

        <div
          className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300 ease-in-out"
          data-testid="atendimentos-por-dia"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg font-medium text-gray-700">
                Média de Atendimentos por Dia
              </p>
              <p
                className="text-4xl font-extrabold text-gray-900 mt-2"
                aria-live="polite"
              >
                {atendimentosPorDiaValido.toFixed()}
              </p>
            </div>
            <FaChartLine
              className="text-5xl text-orange-500 opacity-75"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

RelatorioResumo.propTypes = {
  totalAtendimentos: PropTypes.number,
  pacientesUnicos: PropTypes.number,
  atendimentosPorDia: PropTypes.number,
};

export default RelatorioResumo;
